import { render, staticRenderFns } from "./TableContainer.vue?vue&type=template&id=5b344013&scoped=true&"
import script from "./TableContainer.vue?vue&type=script&lang=js&"
export * from "./TableContainer.vue?vue&type=script&lang=js&"
import style0 from "./TableContainer.vue?vue&type=style&index=0&id=5b344013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b344013",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
